import React, { useEffect } from 'react';
import TripRouteAccordionContent from '@/components/modules/trip-route-details/trip-route-accordion/trip-route-accordion-content/trip-route-accordion-content';
import { InteractedItem } from '@/components/modules/trip-route-details/trip-route-details';
import { isDescriptionItem } from '@/components/modules/trip-route-details/trip-route-details.adapter';

export interface TripRouteAccordionSingleProps {
  /** The interacted item */
  interactedItem?: InteractedItem;
  /** Indicates whether the accordion is open */
  isActive?: boolean;
  /** The accordion item */
  item: Content.Properties.DescriptionItem;
  /** The identification for the accordion */
  itemIndex?: number;
  /** An event that is triggered on click */
  onClick?: () => void;
  /** An event that is triggered when accordion item is selected */
  onSelect?: (id?: string) => void;
}

const TripRouteAccordionSingle = ({
  interactedItem,
  isActive,
  item,
  itemIndex,
  onClick,
  onSelect,
}: TripRouteAccordionSingleProps) => {
  const itemId = item.pointOfInterest?.id;

  const onClickItem = () => {
    onClick?.();

    onSelect?.(itemId);
  };

  useEffect(() => {
    if (!interactedItem) return;

    if (interactedItem.itemId !== itemId) return;

    onClickItem();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [interactedItem]);

  return (
    <React.Fragment>
      {isDescriptionItem(item) && (
        <TripRouteAccordionContent
          isActive={isActive}
          item={item}
          itemIndex={itemIndex}
          onClick={onClickItem}
        />
      )}
    </React.Fragment>
  );
};

TripRouteAccordionSingle.displayName = 'TripRouteAccordionSingle';

export default TripRouteAccordionSingle;
